export const subtitles = {
    "1": {
        "startTime": 63.143,
        "endTime": 68.299,
        "transcript": "Maa-i mikelnguut waniw' naanguarturalalriit.",
        "translation": "Now, you know how children play with toys."
    },
    "2": {
        "startTime": 68.443,
        "endTime": 73.393,
        "transcript": "Ak'allani iciw' inugualallrulriit yaaruilallrulriit maa-i tangerrnailngurmek.",
        "translation": "You know in old times, they would play with small dolls, and tell storyknife stories that we don't see now."
    },
    "3": {
        "startTime": 73.837,
        "endTime": 76.87,
        "transcript": "Naliat umyuarteqsit anglananrungacetua:",
        "translation": "Which do you think is more fun:"
    },
    "4": {
        "startTime": 76.87,
        "endTime": 83.558,
        "transcript": "Maa-i mikelnguut yaaruiyuilnguut, inuguayuilnguut, wall'u-qaa inuguatellret wall' yaaruitellret?",
        "translation": "The children who do not tell storyknife stories or play with dolls, or the ones who played with dolls and storyknives?"
    },
    "5": {
        "startTime": 85.272,
        "endTime": 92.07,
        "transcript": "Makut-wa mikelnguut Kass'artarnek naanguarameng naangualaameng",
        "translation": "Because these children play with Western toys"
    },
    "6": {
        "startTime": 93.02,
        "endTime": 99.89,
        "transcript": "Tiiviinek tuaten tangvagluteng ak'a naanguangqelput pinrirluki.",
        "translation": "They've started watching TV, and stopped playing with the toys that we had back then."
    },
    "7": {
        "startTime": 100.924,
        "endTime": 111.991,
        "transcript": "Ak'a atam wangkuta nasaurluullemteńi yaaruiyunqellruukut.",
        "translation": "You see, back when we were girls, we liked to tell storyknife stories."
    },
    "8": {
        "startTime": 112.266,
        "endTime": 117.28,
        "transcript": "Tua-i yaaruin-llu tegumiaqluku kesianek.",
        "translation": "We always had a storyknife with us."
    },
    "9": {
        "startTime": 119.081,
        "endTime": 121.071,
        "transcript": "Cakuciullruat yaaruit?",
        "translation": "What were the storyknives made of?"
    },
    "10": {
        "startTime": 121.476,
        "endTime": 125.399,
        "transcript": "Yaaruitengqelallruunga wii tulurrarmek tulurmek.",
        "translation": "I had a storyknive made of a little ivory, ivory."
    },
    "11": {
        "startTime": 126.119,
        "endTime": 132.796,
        "transcript": "Ivory, kia-ll' tayim piliaqellruagu. Tua-i yaaruilrianga taqsuunii.",
        "translation": "Ivory, and I'm not sure who made it. I would never stop telling storyknife stories."
    },
    "12": {
        "startTime": 133.479,
        "endTime": 143.16,
        "transcript": "Friend-angqelaamta-llu friend-aput-llu elitnaunritaqamta tua-i yaaruiq tau͡gaam.",
        "translation": "Since we had friends, when our friends and we weren't in school, there was only storyknife stories."
    },
    "13": {
        "startTime": 143.311,
        "endTime": 156.13,
        "transcript": "Yaaruinaurtukut, yaaruiyarapuk-llu wangkuk friend-aqa-llu aterluteng taukut nunat. Aterluteng Pingkuunguarluteng",
        "translation": "We would tell storyknife stories, and my friend's and my way of telling stories, those villages had names. We preteneded they were Inlanders."
    },
    "14": {
        "startTime": 158.177,
        "endTime": 161.74,
        "transcript": "Tamakut ilait qalartelalci Pingkuunguurluci?",
        "translation": "Some of the ones you talked about were the Inlanders?"
    },
    "15": {
        "startTime": 162.12,
        "endTime": 165.055,
        "transcript": "Cakucimek qalartelallruceci, qanemcilallruceci?",
        "translation": "What kinds of things would you tell stories about?"
    },
    "16": {
        "startTime": 165.226,
        "endTime": 168.725,
        "transcript": "Family-unguartelluki. Ukut-gguq",
        "translation": "We made them a family. We said that this village"
    },
    "17": {
        "startTime": 170.382,
        "endTime": 175.696,
        "transcript": "Aiparnatukat tua-i acirnaurai Pingkuunguartelluki.",
        "translation": "She would call the partners Inlanders."
    },
    "18": {
        "startTime": 175.749,
        "endTime": 183.743,
        "transcript": "Ukut-wa-gguq Nunapigngiaraankut ukut-wa Ceñaqviuksuunkut yaaqlikacagaugurarcetaqlukek.",
        "translation": "These was Nunapigngiar and family, and this was Ceńaqviuksuk and family were always the furthest over there."
    },
    "19": {
        "startTime": 183.823,
        "endTime": 189.46,
        "transcript": "Nunapigngiaraankut tua-i acirluki tamakut yuut.",
        "translation": "She named those people Nunapigngiar and family."
    },
    "20": {
        "startTime": 189.932,
        "endTime": 194.385,
        "transcript": "Family-linguaraqluta-ll' eneliliuki tua-i.",
        "translation": "We made up families and made them houses."
    },
    "21": {
        "startTime": 195.793,
        "endTime": 199.565,
        "transcript": "Pinqurraungnaqluteng? Assinqurraungnaqluteng?",
        "translation": "Did they try to be the greatest? Did they try to be the best?"
    },
    "22": {
        "startTime": 199.708,
        "endTime": 207.88,
        "transcript": "Cangqerruartelluki tua-i wangkucicetun wangkuta tangvallemcetun. Pilallratun pinguarcequ'urluku",
        "translation": "She gave them little things like us that we've seen. She would have them do as she did."
    },
    "23": {
        "startTime": 209.55,
        "endTime": 216.693,
        "transcript": "Yaaruinritaqamta-llu atakumi airrarluta imkunek string.",
        "translation": "And when we didn't tell storyknife stories, we would play string games with string."
    },
    "24": {
        "startTime": 219.433,
        "endTime": 228.527,
        "transcript": "Tau͡gaam inerquraqluta ak'anun airraasqevkenata egacuayagmun iterciqniluta.",
        "translation": "But they would admonish us against playing string games for long, saying that a legendary little person would come in on us."
    },
    "25": {
        "startTime": 229.18,
        "endTime": 236.588,
        "transcript": "Camun airralriamun. Tua-i ak'anun pivkenata airrarraarluta taq'aqluta.",
        "translation": "[It would come in] to those playing string games. We wouldn't play string games for long, then quit."
    },
    "26": {
        "startTime": 237.461,
        "endTime": 241.067,
        "transcript": "Ciin-kiq?",
        "translation": "I wonder why?"
    },
    "27": {
        "startTime": 241.225,
        "endTime": 248.524,
        "transcript": "I dunno. Kiagmi-llu, kiagmi-ll' inuguaraqluta",
        "translation": "I don't know. And in the summer, we would play with small dolls."
    },
    "28": {
        "startTime": 249.496,
        "endTime": 254.128,
        "transcript": "Inuguangqerrluta, almost every girl.",
        "translation": "We had small dolls, almost every girl."
    },
    "29": {
        "startTime": 255.615,
        "endTime": 264.1,
        "transcript": "Inuguangqerraqluteng amllernek inuguanek. Family-cuaraugaqluteng ukut.",
        "translation": "They would have a lot of small dolls. This would make up a small family."
    },
    "30": {
        "startTime": 264.5,
        "endTime": 271.66,
        "transcript": "Makut-wa cali irniaruat, tamakunek naanguangqelallruukut.",
        "translation": "And these dolls, we had those toys too."
    },
    "31": {
        "startTime": 275.576,
        "endTime": 278.271,
        "transcript": "Canek cali naanguartangqelallruat?",
        "translation": "What other toys were there?"
    },
    "32": {
        "startTime": 278.849,
        "endTime": 282.727,
        "transcript": "Inuguanek pingqelallrulriakut wangkuta.",
        "translation": "We had small dolls."
    },
    "33": {
        "startTime": 284.445,
        "endTime": 290.32,
        "transcript": "Irniaruanek-llu tua-i tau͡gaam uksu'rqan qemagtaqluki irniaruat.",
        "translation": "And dolls, but when winter set, we would store away the dolls."
    },
    "34": {
        "startTime": 290.401,
        "endTime": 297.228,
        "transcript": "Tau͡gaam inuguatuluta enemi irniaruayuunata tau͡gaam anluta ellami.",
        "translation": "We only played with small dolls in the house, not dolls, but we went outside [to play with the dolls]."
    },
    "35": {
        "startTime": 297.773,
        "endTime": 304.561,
        "transcript": "Nutaan tau͡gaam up'nerkami yaqulget tekitaqata nutaan irniaruaryaurtaqluta.",
        "translation": "Only when the birds came in the spring would we then start playing with dolls."
    },
    "36": {
        "startTime": 305.555,
        "endTime": 309.515,
        "transcript": "Ciin-gguq anucuunaki? Qaill' qanlallruat?",
        "translation": "Why wouldn't you bring them out? What would they say?"
    },
    "37": {
        "startTime": 309.52,
        "endTime": 313.554,
        "transcript": "Irniaruat, irniaruat tamakut anucuunaki.",
        "translation": "We wouldn't bring those dolls out."
    },
    "38": {
        "startTime": 313.851,
        "endTime": 319.622,
        "transcript": "Anuskumteki-gguq' ella-gguq imkuciquq",
        "translation": "They said that if we bring them out, the weather will, you know"
    },
    "39": {
        "startTime": 320.149,
        "endTime": 329.657,
        "transcript": "Kiagciiganani, pircirturluni, allauguurciqniluki. Irniaruat anucuunaki.",
        "translation": "Summer would set late, constant blizzards, they said it would be strange. We wouldn't bring dolls out."
    },
    "40": {
        "startTime": 331.444,
        "endTime": 333.076,
        "transcript": "Kenirualallruuci?",
        "translation": "Would you pretend to cook?"
    },
    "41": {
        "startTime": 333.198,
        "endTime": 334.002,
        "transcript": "Calarta?",
        "translation": "Do what?"
    },
    "42": {
        "startTime": 334.1,
        "endTime": 334.94,
        "transcript": "Keniruaq.",
        "translation": "Pretend to cook."
    },
    "43": {
        "startTime": 336.259,
        "endTime": 343.875,
        "transcript": "Naanguatullruukut, ellami-llu naanguarturatullruukut eneliluta canegnek.",
        "translation": "We always played, and we played outside making houses out of grass."
    },
    "44": {
        "startTime": 344.104,
        "endTime": 353.14,
        "transcript": "Elagyaliluta tupigluki. Naanguaraqluta irniaruaqluki cat aanakegnguarluki.",
        "translation": "We wove grass into caches. We would play, pretending to have children and mothers."
    },
    "45": {
        "startTime": 354.8,
        "endTime": 360.197,
        "transcript": "Keniruarluta cat tua-i canguarturluta.",
        "translation": "We pretended to cook, pretended to do things."
    },
    "46": {
        "startTime": 361.901,
        "endTime": 365.784,
        "transcript": "Uluangqenguaraqluci?",
        "translation": "Would you pretend to have women's knives?"
    },
    "47": {
        "startTime": 365.824,
        "endTime": 366.611,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "48": {
        "startTime": 366.745,
        "endTime": 371.274,
        "transcript": "Canek? Canek uluangqaqluci cakucinek?",
        "translation": "Out of what? What kinds of women's knives would you have?"
    },
    "49": {
        "startTime": 371.678,
        "endTime": 375.229,
        "transcript": "Canek uluangqelallruceta tayima?",
        "translation": "What kinds of women's knives did we have?"
    },
    "50": {
        "startTime": 377.051,
        "endTime": 382.229,
        "transcript": "Aturalinguaraqluki-ll' quagcinek.",
        "translation": "We would also make clothes for them out of sourdock."
    },
    "51": {
        "startTime": 382.71,
        "endTime": 388.265,
        "transcript": "Canegnek imkurluki. Anglanitullruukut naanguaraqamta wangkuta.",
        "translation": "We used grass for them. We would have fun when we played."
    },
    "52": {
        "startTime": 388.793,
        "endTime": 402.536,
        "transcript": "Tamaa-i-llu angliringengllemni inuguarnanringlua yaaruissiyaayuirullua-ll'.",
        "translation": "And back when I had grown a little, I stopped playing with small dolls and didn't tell too many storyknife stories anymore."
    },
    "53": {
        "startTime": 402.536,
        "endTime": 406.674,
        "transcript": "Kiagmi tau͡gaam angualgullruunga egelrutkun.",
        "translation": "But in the summer, I always paddled with a canoe."
    },
    "54": {
        "startTime": 406.75,
        "endTime": 413.58,
        "transcript": "Tua-i yuilqumun ayalrianga arulaiyuunii every day ella-llu assilallruami.",
        "translation": "I never stopped going to the wilderness every day because the weather would also be good."
    },
    "55": {
        "startTime": 415.504,
        "endTime": 425.363,
        "transcript": "Irniaten-qaa elicallruaten waniw' tamakunek aquinermek, inugualinermek?",
        "translation": "Did you teach your children to play like that, to make small dolls?"
    },
    "56": {
        "startTime": 425.424,
        "endTime": 432.507,
        "transcript": "Inugualillrunrilkenka-wa irnianka irniaruangqelallruut tau͡gaam.",
        "translation": "I didn't make my children small dolls, but they had dolls."
    },
    "57": {
        "startTime": 433.367,
        "endTime": 440.91,
        "transcript": "Irniaruanek yaaruivkangnaqaqluki-ll' yaaruiqtaraqluteng quliringuarluteng.",
        "translation": "Dolls, and I tried to have them tell storyknife stories, and they would pretend to tell legends."
    },
    "58": {
        "startTime": 441.08,
        "endTime": 446.272,
        "transcript": "Maa-i-mi waniw' mikelnguut tuaten piyuurlu(?)",
        "translation": "What about the children [?who do not] do that today?"
    },
    "59": {
        "startTime": 446.351,
        "endTime": 451.691,
        "transcript": "Tut'garaanka maa-i Kass'artarnek tau͡gaam naanguarluteng.",
        "translation": "My grandchildren now only play with Western toys."
    },
    "60": {
        "startTime": 451.93,
        "endTime": 455.299,
        "transcript": "Naanguanritaqameng tiiviiraqluteng",
        "translation": "When they don't play, they watch TV."
    },
    "61": {
        "startTime": 457.13,
        "endTime": 459.857,
        "transcript": "Anglaniciqngatut yaaruiyauruskata?",
        "translation": "Do you think they'll have fun if they tell storyknife stories?"
    },
    "62": {
        "startTime": 460.359,
        "endTime": 463.518,
        "transcript": "Yaaruilaquneng-wa anglaniciqellriit.",
        "translation": "They would have fun if they told storyknife stories."
    },
    "63": {
        "startTime": 464.185,
        "endTime": 467.818,
        "transcript": "Anglanarqetullruut-ll' wangkuta yaaruitullemteni.",
        "translation": "It was also fun when we told storyknife stories."
    },
    "64": {
        "startTime": 469.71,
        "endTime": 478.84,
        "transcript": "Au͡gkunek angutet ayagaqataratameng waniw' qaillun neq'litlallruceciu?",
        "translation": "When the men were going to travel, how would you prepare food for them?"
    },
    "65": {
        "startTime": 480.012,
        "endTime": 486.56,
        "transcript": "Qaillun upyut'lallruceciki iciw' ayagyuallerpeni aatan wall'u-q'",
        "translation": "How would you prepare things for them, you know, when you were small for your father or"
    },
    "66": {
        "startTime": 486.69,
        "endTime": 492.148,
        "transcript": "Uingellerpeni uin pissuryaqataqan qavcinek tayim week-ani?",
        "translation": "Or when you took a husband, when your husband was going to go for several weeks?"
    },
    "67": {
        "startTime": 492.296,
        "endTime": 499.63,
        "transcript": "Ataka tua-i ayakataraqan aanama tua-i upnauraa",
        "translation": "When my father was going to travel, my mother would prepare for him"
    },
    "68": {
        "startTime": 500.42,
        "endTime": 509.46,
        "transcript": "Neqkainek, saayunek, saarralamek. Kenircuutaicuunateng.",
        "translation": "Food, tea, sugar for him. They always had portable stoves."
    },
    "69": {
        "startTime": 509.882,
        "endTime": 518.993,
        "transcript": "Tamaa-i tau͡gaam ella assiraqan ellakun kenituluteng tamakut angutet.",
        "translation": "But when the weather was good, those men would cook outside."
    },
    "70": {
        "startTime": 521.995,
        "endTime": 526.674,
        "transcript": "Ellmeggnek-qaa neqnek piaqluteng pissuraqluteng?",
        "translation": "Would they get their own food by hunting?"
    },
    "71": {
        "startTime": 526.845,
        "endTime": 528.12,
        "transcript": "Ii-i",
        "translation": "Yes."
    },
    "72": {
        "startTime": 529.744,
        "endTime": 536.62,
        "transcript": "Maaten-llu pinauranka kuvyinaurtut string-anek pililuteng.",
        "translation": "Then I would notice that they would make drift nets out of [a certain type of] string."
    },
    "73": {
        "startTime": 536.751,
        "endTime": 544.451,
        "transcript": "Ataka-llu neqsurcuuciaqluni muragnek canaluni taluyaliluni.",
        "translation": "My father would also make a fishing tool by carving wood, making fish traps."
    },
    "74": {
        "startTime": 545.3,
        "endTime": 557.61,
        "transcript": "Can'giircuutnek pissurcuuciaqluteng-llu taluyanek kapkaananek ilaluku angutet tangvalallrenká",
        "translation": "The men I watched would make fish traps for blackfish, and they added steel traps."
    },
    "75": {
        "startTime": 557.71,
        "endTime": 564.25,
        "transcript": "Aipaqa-ll' pilallruuq wangkuk aipaqliucamegnuk. Uksuiyalgulunuk up'nerkiyaraqlunuk",
        "translation": "My spouse did too when we got married. We always went to winter and spring camp."
    },
    "76": {
        "startTime": 564.34,
        "endTime": 573.86,
        "transcript": "Maaten-llu tamaani ilamni uitallemni with my parents angayuqaagemni uitallemni",
        "translation": "Then I realized that back when I lived with my family, my parents, when I lived with my parents"
    },
    "77": {
        "startTime": 574.012,
        "endTime": 578.459,
        "transcript": "Up'nerkallra tamalkuan upatuluta March-ami.",
        "translation": "Every spring, we would move in March."
    },
    "78": {
        "startTime": 578.986,
        "endTime": 582.548,
        "transcript": "Pelatakaraqluta qanikcaam qainganun.",
        "translation": "We would set tents on the snow."
    },
    "79": {
        "startTime": 582.853,
        "endTime": 589.288,
        "transcript": "Amta-ll' tang qerruteksaunata. Kaminiaq-llu elliluku qanikcaam qainganun.",
        "translation": "And yet we weren't cold. And we put the stove on the snow."
    },
    "80": {
        "startTime": 591.001,
        "endTime": 595.398,
        "transcript": "Pelatekami tua-i uitanaurtukut March-amek ayagluta.",
        "translation": "We would live in the tent starting from March."
    },
    "81": {
        "startTime": 596.153,
        "endTime": 601.829,
        "transcript": "Upagaqamta qavartaraqluta tua-i-ll' qavartarraarluta call'",
        "translation": "When we moved, we would camp, then after we camped"
    },
    "82": {
        "startTime": 601.829,
        "endTime": 607.559,
        "transcript": "Qaniilarraarluta, qaniilarraarluni ataka",
        "translation": "After we took our supplies ahead, after our father took our supplies ahead"
    },
    "83": {
        "startTime": 607.807,
        "endTime": 613.37,
        "transcript": "Nunakamteńun tekitaqluta nutaan. Nunaniqnaurtuq.",
        "translation": "We would then reach where we would stay. It would be wonderful."
    },
    "84": {
        "startTime": 614.48,
        "endTime": 616.36,
        "transcript": "Ella-ll' assilaami",
        "translation": "And because the weather would be good"
    },
    "85": {
        "startTime": 616.616,
        "endTime": 620.61,
        "transcript": "Pelatekami uitangramta qerrucuunata.",
        "translation": "Even though we stayed in the tent, we wouldn't be cold."
    },
    "86": {
        "startTime": 620.61,
        "endTime": 625.283,
        "transcript": "Elisngaluku tuaten pituamta nutem.",
        "translation": "We were used to it since we had always done that."
    },
    "87": {
        "startTime": 625.611,
        "endTime": 629.718,
        "transcript": "March-ami pelatekami uitaaqluta.",
        "translation": "In March, we would live in a tent."
    },
    "88": {
        "startTime": 632.352,
        "endTime": 634.117,
        "transcript": "Anurviilallruuci?",
        "translation": "Would you be hit by strong winds?"
    },
    "89": {
        "startTime": 634.142,
        "endTime": 637.733,
        "transcript": "Iliini sometimes anuqliraqluni.",
        "translation": "It would be windy sometimes."
    },
    "90": {
        "startTime": 637.741,
        "endTime": 642.317,
        "transcript": "Tau͡gaam aturnaqluni anuqliraqluni.",
        "translation": "But we would be able to use [the tent] in the wind."
    },
    "91": {
        "startTime": 642.913,
        "endTime": 646.489,
        "transcript": "Kiagyugaqami ellallirluni-ll' piaqluni.",
        "translation": "And as summer was approaching, it would be rainy."
    },
    "92": {
        "startTime": 646.74,
        "endTime": 650.769,
        "transcript": "Nunanirqaqluni akercirluni-ll' ella.",
        "translation": "It would be wonderful with sunny weather."
    },
    "93": {
        "startTime": 651.988,
        "endTime": 657.029,
        "transcript": "Elpeci-mi arnani calallruceci ayagaaqavci?",
        "translation": "So what would you women do when you traveled?"
    },
    "94": {
        "startTime": 657.1,
        "endTime": 658.155,
        "transcript": "Ayagaaqamta-qaa?",
        "translation": "When we traveled?"
    },
    "95": {
        "startTime": 658.205,
        "endTime": 659.828,
        "transcript": "Maliggluki iciw' March-aami.",
        "translation": "Going with them, you know, in March."
    },
    "96": {
        "startTime": 660.771,
        "endTime": 661.829,
        "transcript": "March-ami-qaa?",
        "translation": "In March?"
    },
    "97": {
        "startTime": 661.945,
        "endTime": 667.164,
        "transcript": "Iciw' ava-i qanruskevkuk ayagalallrulriaci right, March-aami?",
        "translation": "You know, you just told us that you would travel, right, in March?"
    },
    "98": {
        "startTime": 667.543,
        "endTime": 671.848,
        "transcript": "Pelatekami uitaurluci, arnani calallruceci?",
        "translation": "Living in a tent, what would you women do?"
    },
    "99": {
        "startTime": 672.006,
        "endTime": 674.839,
        "transcript": "Wiinga atam equgtaryunqellruunga.",
        "translation": "You see, I liked to gather wood."
    },
    "100": {
        "startTime": 675.392,
        "endTime": 681.85,
        "transcript": "Tua-i unuakuarmi, early morning, erqaararaqan",
        "translation": "Early in the morning, right after dawn"
    },
    "101": {
        "startTime": 682.237,
        "endTime": 686.539,
        "transcript": "Maklua equgtarnaurtua",
        "translation": "I would get up and gather wood"
    },
    "102": {
        "startTime": 686.91,
        "endTime": 692.419,
        "transcript": "'cause I was the oldest one, family-ni wiinga alqaullruama.",
        "translation": "'cause I was the oldest one, because I was the eldest sister in the family."
    },
    "103": {
        "startTime": 695.88,
        "endTime": 700.238,
        "transcript": "Equgtalgullruunga assikluku equgtaneq",
        "translation": "I always gathered wood, enjoying gathering wood."
    },
    "104": {
        "startTime": 702.601,
        "endTime": 704.535,
        "transcript": "Aanan-mi calallrua?",
        "translation": "So what would your mother do?"
    },
    "105": {
        "startTime": 704.765,
        "endTime": 709.597,
        "transcript": "Aanaka tua-i arulaiqsaunani upluki cat",
        "translation": "My mother never stopped preparing things"
    },
    "106": {
        "startTime": 710.033,
        "endTime": 716.625,
        "transcript": "Atu'urkai-llu atamta taum, ivrucililuki-llu.",
        "translation": "Everyhing my father would need, and she would make them waterproof skin boots."
    },
    "107": {
        "startTime": 717.8,
        "endTime": 724.437,
        "transcript": "Tamalkumta-ll' ivrucingqerraqluta, water boots pilianek.",
        "translation": "And all of us had waterproof skin boots, handmade water boots."
    },
    "108": {
        "startTime": 724.568,
        "endTime": 729.484,
        "transcript": "Up'nerkami tamaa-i tamakunek aturaqluta ivrucinek.",
        "translation": "We would use those waterproof skin boots in the spring."
    },
    "109": {
        "startTime": 729.49,
        "endTime": 732.603,
        "transcript": "Canek piliaqumaluteng? Canek piliumaaluteng?",
        "translation": "What were they made of? What were they made of?"
    },
    "110": {
        "startTime": 732.659,
        "endTime": 737.17,
        "transcript": "Tuntuvallugnek ivrucingqerraqluta, tunturpallurnek.",
        "translation": "We had waterproof moose skin boots, large caribou skins."
    },
    "111": {
        "startTime": 737.391,
        "endTime": 740.752,
        "transcript": "Tuntut amlletullruut ak'a.",
        "translation": "There used to be a lot of moose a long time ago."
    },
    "112": {
        "startTime": 740.852,
        "endTime": 743.947,
        "transcript": "All over, tuntut amllerluteng.",
        "translation": "All over, there were a lot of caribou."
    },
    "113": {
        "startTime": 743.947,
        "endTime": 757.83,
        "transcript": "Tua-i-llu 1941 tuntut wani tuquluteng amlleq.",
        "translation": "And then in 1941, a lot of caribou died."
    },
    "114": {
        "startTime": 758.013,
        "endTime": 761.743,
        "transcript": "Keglunret tuaten-gguq nerluki.",
        "translation": "They also said wolves ate them."
    },
    "115": {
        "startTime": 761.779,
        "endTime": 767.034,
        "transcript": "Tuntut-llu catairulluteng tuntutairulluni.",
        "translation": "Then the caribou were gone, no more caribou."
    },
    "116": {
        "startTime": 769.276,
        "endTime": 776.87,
        "transcript": "Qessatulit arnat angayuqat ca qaill' pilallruaki, qessamkat arnat?",
        "translation": "What would the parents do to lazy women, the lazy women?"
    },
    "117": {
        "startTime": 780.144,
        "endTime": 783.272,
        "transcript": "Qessamkat-wa arnat ellimelallikait.",
        "translation": "They probable told the lazy women to do things."
    },
    "118": {
        "startTime": 783.38,
        "endTime": 791.95,
        "transcript": "Qaillun qanruyutengqelallruat qessanqurnun?",
        "translation": "What traditional wisdom would they have for lazy people?"
    },
    "119": {
        "startTime": 792.171,
        "endTime": 797.361,
        "transcript": "Wiinga-wa atama tau͡gaam qanrupallutullruanga.",
        "translation": "For me, mostly only my father taught me."
    },
    "120": {
        "startTime": 801.96,
        "endTime": 809.973,
        "transcript": "Waten qanrullua: wiinga-gguq qessanqerrukuma-gguq wiinga cam-gguq atam iliini",
        "translation": "He told me this: if I am lazy, to see that someday"
    },
    "121": {
        "startTime": 811.58,
        "endTime": 814.626,
        "transcript": "Yuungnaqniartua wangnek.",
        "translation": "I will try to make my own living."
    },
    "122": {
        "startTime": 815.3,
        "endTime": 820.201,
        "transcript": "Tua-i-llu-gguq qessanqurrukuma caitelarciqlua.",
        "translation": "And then if I am lazy, I won't have anything."
    },
    "123": {
        "startTime": 820.856,
        "endTime": 828.824,
        "transcript": "Qessaksaunii-gguq canek cauralaqilii makut yuut cayarait tangerrluki.",
        "translation": "He told me not to be lazy but to continously work, looking at the way these people do things."
    },
    "124": {
        "startTime": 829.532,
        "endTime": 835.07,
        "transcript": "Kiagmi-llu cat atsat-llu naukata atsanek iqvarlua.",
        "translation": "And when berries grow in the summer, to pick berries."
    },
    "125": {
        "startTime": 837.52,
        "endTime": 842.99,
        "transcript": "Pistengqerquma-llu-gguq pisteka neqnek pikan neqet aulukluki.",
        "translation": "And he said that if I have a provider, if my provider catches fish, to take care of the fish."
    },
    "126": {
        "startTime": 843.719,
        "endTime": 850.166,
        "transcript": "Kenekluki qessalerutevkenaki uqlautevkenaki-llu.",
        "translation": "I should treat them with love, not be disinclined to do them, and not make a mess of them."
    },
    "127": {
        "startTime": 850.694,
        "endTime": 856.01,
        "transcript": "Au͡gkut yuut tangvallrenka angayuqaagka",
        "translation": "The people I saw back, my parents"
    },
    "128": {
        "startTime": 856.127,
        "endTime": 863.92,
        "transcript": "Neqnek uqlauciyuitut uqlauciyuiteqapiarallruut, neqet kencikluki.",
        "translation": "They didn't make a mess of fish, never made a mess, out of reverence for the fish."
    },
    "129": {
        "startTime": 865.63,
        "endTime": 872.19,
        "transcript": "Enrraungraan-llu natermun pisqessuunaki kenekluki.",
        "translation": "Even if they're bones, they told us not to put them on the floor out of love."
    },
    "130": {
        "startTime": 872.545,
        "endTime": 879.664,
        "transcript": "Kencikluki. Tua-i-gguq atam kencikenrilkumteki tutmautelaqumteki-ll'",
        "translation": "To revere them. He said, you see, that if we do not revere them and tread upon them"
    },
    "131": {
        "startTime": 880.47,
        "endTime": 882.67,
        "transcript": "Pikaitelarniartukut.",
        "translation": "We won't have things."
    },
    "132": {
        "startTime": 885.252,
        "endTime": 892.17,
        "transcript": "Wall' kuvyaput cangyuunateng, wall' taluyat cangyuunateng kenkenrilamteki.",
        "translation": "Or our drift nets will not catch anything, or our fish traps will not catch anything because we don't love them."
    },
    "133": {
        "startTime": 892.252,
        "endTime": 900.01,
        "transcript": "Cat tamalkuita kencikiurluki pisqaqluta, aturaqengramteki-llu kenkurluki.",
        "translation": "They told us to revere everything, and to even treat our clothes with love."
    },
    "134": {
        "startTime": 900.182,
        "endTime": 906.537,
        "transcript": "Maa-i-ll' wii man'a tekilluku canek uqlauciiyuilngua.",
        "translation": "And now, to this day, I do not make a mess of anything."
    },
    "135": {
        "startTime": 906.761,
        "endTime": 913.03,
        "transcript": "Cat-llu amllengrraata uqlaucuunaki kenkurluki tau͡gaam kenciku'urluki.",
        "translation": "And even though there's a lot of things, I do not make a mess of them out of love, but revere them."
    },
    "136": {
        "startTime": 919.814,
        "endTime": 925.578,
        "transcript": "Au͡gkunek neqet iciw' poison-angqellriit neqet poison-angqellriit. Qaill' nallunritullrusiki?",
        "translation": "And you know that fish have poison, fish have poison. How would you tell them apart?"
    },
    "137": {
        "startTime": 925.603,
        "endTime": 932.205,
        "transcript": "Ak'a tamakut tangvalallrenka yuut neqet kencikluki",
        "translation": "The people I watched a long time ago would revere fish"
    },
    "138": {
        "startTime": 932.449,
        "endTime": 937.047,
        "transcript": "Neqliaqetullruit akercircecuunaki.",
        "translation": "They would not let the fish they worked on be exposed to the sun."
    },
    "139": {
        "startTime": 938.173,
        "endTime": 942.499,
        "transcript": "Kuvyami-llu kuvyam cangtai akercillret",
        "translation": "And on the net, what had been caught in the net that had been exposed to the sun"
    },
    "140": {
        "startTime": 942.506,
        "endTime": 947.739,
        "transcript": "Qimugteńun tau͡gaam neqkiutuluki qerruqallret qerruqsagtellret.",
        "translation": "They would prepare the ones that had bloated to be food only for dogs."
    },
    "141": {
        "startTime": 947.966,
        "endTime": 956.43,
        "transcript": "Taumek ilussaqercuitellrulriit. Ilussaqertellriamek-wa tangvallrunrilngua yugmek kitumek.",
        "translation": "That's why they never had food poisining. I've never seen any person have food poisoning."
    },
    "142": {
        "startTime": 956.775,
        "endTime": 963.308,
        "transcript": "Grow up-aallemni-llu-wa angliyugallemni amlleq yuk tuquksaitellrulria.",
        "translation": "And when I had grown up, not many people died."
    },
    "143": {
        "startTime": 963.308,
        "endTime": 971.36,
        "transcript": "Once in a great while yuk tuquaqluni. Naulluussiyaayuunateng-llu yuut tangvallrenka.",
        "translation": "Once in a great while, a person would die. And the people I saw wouldn't get sick too often."
    },
    "144": {
        "startTime": 971.401,
        "endTime": 975.86,
        "transcript": "Cali-ll' taangiqellriamek tangyuitellruunga.",
        "translation": "And I never saw anyone drunk."
    },
    "145": {
        "startTime": 976.23,
        "endTime": 981.59,
        "transcript": "Sixteen-aallemni tau͡gaam first time taangiqellriamek tangerrlua.",
        "translation": "But when I was 16, I saw someone drunk for the first time."
    },
    "146": {
        "startTime": 981.868,
        "endTime": 987.16,
        "transcript": "Maa-i nasaurluut 16-aaraqameng iciw' taqnerurtelalriit.",
        "translation": "Now when girls are 16, you know, they become adults."
    },
    "147": {
        "startTime": 987.952,
        "endTime": 994.211,
        "transcript": "Arnaurrnaciallruama-ll'-wii 16-aallemni tau͡gaam arnaurtellruama.",
        "translation": "I became a woman late because I became a woman when I was 16."
    },
    "148": {
        "startTime": 995.704,
        "endTime": 1002.76,
        "transcript": "Aipangellrulua-ll' 18-aallemni tau͡gaam au͡g'umek aipamnek. Parents-aagma aiparkarrlua.",
        "translation": "And I got married to my spouse when I was 18. My parents chose my spouse."
    },
    "149": {
        "startTime": 1011.867,
        "endTime": 1014.424,
        "transcript": "Mingqiilallernek-mi?",
        "translation": "What about those who sewed grass?"
    },
    "150": {
        "startTime": 1015.264,
        "endTime": 1022.018,
        "transcript": "Wiinga ellangellruunga mingqiiyuilngurni, tau͡gaam canegnek tupigaqluteng.",
        "translation": "I didn't grow up with those who sewed grass, but they would weave grass."
    },
    "151": {
        "startTime": 1022.351,
        "endTime": 1031.688,
        "transcript": "Arnat-llu arnassagaurtellriit curunek kelugkanek",
        "translation": "And then women who had gotten older would make mats out of coarse grass"
    },
    "152": {
        "startTime": 1031.992,
        "endTime": 1037.336,
        "transcript": "Tupigluteng mallgulluki. Assipianek tupignaurtut.",
        "translation": "They would tightly weave them. They wove great things."
    },
    "153": {
        "startTime": 1037.553,
        "endTime": 1045.838,
        "transcript": "Wiinga maurluqa tamaa-i tuqullruuq. When I was about eight-aarlua tuqullruyugnarquq.",
        "translation": "My grandmother died back then. I think she died when I was about eight."
    },
    "154": {
        "startTime": 1049.324,
        "endTime": 1057.129,
        "transcript": "Tamaa-i taumek aquinritaqamta-llu arnassagaat ullagluki.",
        "translation": "That why when we weren't playing, we would go to the old women."
    },
    "155": {
        "startTime": 1057.358,
        "endTime": 1062.98,
        "transcript": "Anglaniuratullrukenka caliaqata tupigluteng.",
        "translation": "I would have fun when they worked weaving grass."
    },
    "156": {
        "startTime": 1063.855,
        "endTime": 1071.43,
        "transcript": "Tua-i-llu ukaqvaurtellria Mikelnguut Elitnaurviat ak'allarnek piyugluni.",
        "translation": "Then it's been recently that the Mikelnguut Elitnaurviat wanted old teachings."
    },
    "157": {
        "startTime": 1071.807,
        "endTime": 1078.026,
        "transcript": "Old things. Mother-aaqa unguvallrani mother-aaqa pilisqessaaqluku.",
        "translation": "Old things. When my mother was alive, they asked my mother to make things."
    },
    "158": {
        "startTime": 1078.343,
        "endTime": 1088.949,
        "transcript": "Ikaraliitnek, aqlitegnek, uyamignek-llu piyugnarqaat, ak'acetun pilisqelluku.",
        "translation": "They asked her to make things in the old way, grass mats for kayaks, earrings, and I think necklaces."
    },
    "159": {
        "startTime": 1089.295,
        "endTime": 1095.107,
        "transcript": "Tua-i-ll' mother-aaqa piuq, ellii-gguq pingaituq. Wii-gguq naspaalii.",
        "translation": "Then my mother said that she wouldn't. She said that I should try."
    },
    "160": {
        "startTime": 1095.468,
        "endTime": 1101.584,
        "transcript": "Tua-i-ll' wii tupiglua arnassagarnek tangvalallrenka ayuqeliluki.",
        "translation": "Then I wove grass, replicating the old women that I used to watch."
    },
    "161": {
        "startTime": 1101.906,
        "endTime": 1107.445,
        "transcript": "Ayuquciirluki tupiglua tegunecuayaalirluki kelugkanek.",
        "translation": "I wove grass like they did, making small warp strands with course grass."
    },
    "162": {
        "startTime": 1107.732,
        "endTime": 1118.65,
        "transcript": "Ilaitnek yualirluki. Waten tupigait ayuqetullruut tamakut: ukut ukatmun, ukut-llu ukatmun.",
        "translation": "I used some of them to thread through. The things they wove would be like this: these going this way, and these going this way."
    },
    "163": {
        "startTime": 1118.826,
        "endTime": 1125.95,
        "transcript": "Tegunecuayaarluteng waten ellegtalrianek. Waten tupigluteng.",
        "translation": "They had small warp strands that were this thick. They wove grass like this."
    },
    "164": {
        "startTime": 1128.796,
        "endTime": 1133.88,
        "transcript": "Ika-i tang tupigayagaq issraksuayaaq. Atam taiteqerr'.",
        "translation": "Look, the little woven grass bag across there. Give it to me."
    },
    "165": {
        "startTime": 1134.022,
        "endTime": 1134.63,
        "transcript": "Una?",
        "translation": "This one?"
    },
    "166": {
        "startTime": 1135.417,
        "endTime": 1140.822,
        "transcript": "Tua-i, nuu, tua-i-tang, yaa, tauna-llu.",
        "translation": "There, no, there it is, yes, that too."
    },
    "167": {
        "startTime": 1148.567,
        "endTime": 1153.421,
        "transcript": "Waten curulilallruut.",
        "translation": "They would make mats like this."
    },
    "168": {
        "startTime": 1155.438,
        "endTime": 1159.947,
        "transcript": "Waten tegunirluku, waten-llu akultutaurluki.",
        "translation": "They made warp strands like, and made the gaps this size."
    },
    "169": {
        "startTime": 1163.561,
        "endTime": 1169.43,
        "transcript": "Wiinga tua-i pililrianga ikaraliitnek.",
        "translation": "I made grass mats for kayaks."
    },
    "170": {
        "startTime": 1170.5,
        "endTime": 1179.25,
        "transcript": "Tua-i-ll' mother-aama tangvaglua pianga, \"Atam-gguq waten-gguq ukatmun-gguq qip'aqluki.\"",
        "translation": "Then my mother watched and said to me, \"Look, twist them this way like this.\""
    },
    "171": {
        "startTime": 1180.419,
        "endTime": 1185.388,
        "transcript": "Tua-i-ll' tuaten pingaarcamteng waten ayuqunga'arluteng.",
        "translation": "Then when I started doing that, they started becoming like this."
    },
    "172": {
        "startTime": 1185.484,
        "endTime": 1195.9,
        "transcript": "Pama-i atam ikaraliiksuaraliallrenka Mikelnguut Elitnaurviatni glass-ani ekumaut, atqa-ll' tuanlluni Elena Charles.",
        "translation": "You see, the small grass mats for kayaks I made are inland in Mikelnguut Elitnaurviat, and my name is there, Elena Charles."
    },
    "173": {
        "startTime": 1196.901,
        "endTime": 1202.583,
        "transcript": "Tua-ll' call' issracisqeńgatnga, issrat'lilua cali iitallernek.",
        "translation": "Then when they asked me to make a woven grass bag, I made a bad out of tall cottongrass."
    },
    "174": {
        "startTime": 1202.739,
        "endTime": 1205.54,
        "transcript": "Waten ayuqluku, ang'urluku tau͡gaam.",
        "translation": "I made it like this, but pretty big."
    },
    "175": {
        "startTime": 1206.638,
        "endTime": 1211.591,
        "transcript": "Terr'a tau͡gaam kan'a takliriluni, taqurluku-ll' iqua.",
        "translation": "But the bottom down there got long, and I braided the end."
    },
    "176": {
        "startTime": 1211.885,
        "endTime": 1214.49,
        "transcript": "Una assirlun' pimauq.",
        "translation": "This is done well."
    },
    "177": {
        "startTime": 1214.494,
        "endTime": 1215.851,
        "transcript": "Acia-llu-q' man'a?",
        "translation": "And the bottom here?"
    },
    "178": {
        "startTime": 1217.977,
        "endTime": 1220.497,
        "transcript": "Assipiarluni un' pimauq.",
        "translation": "This is made very well."
    },
    "179": {
        "startTime": 1221.036,
        "endTime": 1227.83,
        "transcript": "Tegumiaqluku tuaten usgullukek terr'anek piqerr', acia maniluku.",
        "translation": "Please hold it, connecting the bottom parts, showing the bottom."
    },
    "180": {
        "startTime": 1237.545,
        "endTime": 1240.683,
        "transcript": "Canegnek-llu tupignaurtut kalngaliluteng.",
        "translation": "They would also weave grass to make fish carrying bags."
    },
    "181": {
        "startTime": 1240.683,
        "endTime": 1245.725,
        "transcript": "Paper box-aanek piitellermeggni neqet assigtarkiurturaraqluki.",
        "translation": "When they didn't have paper boxes, they always made bags for fish."
    },
    "182": {
        "startTime": 1246.182,
        "endTime": 1248.975,
        "transcript": "Dry fish-aarutait-ll' assiraqluteng.",
        "translation": "And the dry fish they made would be good."
    },
    "183": {
        "startTime": 1249.39,
        "endTime": 1252.74,
        "transcript": "Canegnek tupigluki waten mallegtanun.",
        "translation": "They would weave grass with this close pattern."
    },
    "184": {
        "startTime": 1254.196,
        "endTime": 1256.706,
        "transcript": "Wagg'uq kuusqullugnek.",
        "translation": "They called those kuusqulluut."
    },
    "185": {
        "startTime": 1257.665,
        "endTime": 1265.71,
        "transcript": "Paingit-llu naqeqluki can'get tupiumaluteng, ilavkuliluteng.",
        "translation": "Their openings would be woven, the grass would be woven to make ropes."
    },
    "186": {
        "startTime": 1265.803,
        "endTime": 1269.071,
        "transcript": "Nin'amayiit-qaa cali iluatni uitalallruut?",
        "translation": "Would the aged herring be in them as well?"
    },
    "187": {
        "startTime": 1269.21,
        "endTime": 1275.18,
        "transcript": "Wangkuta nin'amayugnek piyuitellruukut. I'm from tundra.",
        "translation": "We didn't have aged herring. I'm from [the] tundra."
    },
    "188": {
        "startTime": 1276.78,
        "endTime": 1282.58,
        "transcript": "Elliviit-llu, elliivingqerraqluteng every family.",
        "translation": "And caches, every family would have a cache."
    },
    "189": {
        "startTime": 1284.024,
        "endTime": 1287.598,
        "transcript": "Fish cache, kanagarluni muriit.",
        "translation": "Fish cache, and it would have wooden posts."
    },
    "190": {
        "startTime": 1287.89,
        "endTime": 1291.211,
        "transcript": "Pagna umciggluni, wall-aq-ll' umciggluni.",
        "translation": "It was airtight up there, and the wall was airtight."
    },
    "191": {
        "startTime": 1291.331,
        "endTime": 1296.256,
        "transcript": "Natrit tau͡gaam ukinerluteng.",
        "translation": "But their floors had holes."
    },
    "192": {
        "startTime": 1296.58,
        "endTime": 1299.916,
        "transcript": "Neqautait-llu imai assiirucuunateng.",
        "translation": "And the fish in them wouldn't spoil."
    },
    "193": {
        "startTime": 1300.367,
        "endTime": 1304.702,
        "transcript": "Kalngiit-ll' imait neqet kumlanret assipiat.",
        "translation": "And the frozen fish inside the fish bags would be very good."
    },
    "194": {
        "startTime": 1305.542,
        "endTime": 1310.89,
        "transcript": "Dry fish-aat-llu uquggluyuunaki. Assirnaurtut.",
        "translation": "And the dry fish in them wouldn't get mold. They'd be good."
    }
};